import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";

export function ProtectedRoute({ children, requireComplete = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ink-950">
                <div className="animate-pulse">
                    <Logo size="lg" />
                </div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }
    if (requireComplete && !user.profile_complete) {
        return <Navigate to="/onboarding" replace />;
    }
    return children;
}

export default ProtectedRoute;
